module.exports = __webpack_public_path__ + "static/img/student_girl.766a504.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/student_girl.png
// module id = 1Hd8
// module chunks = 79